/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Moving_Time_RangeInputs */

const en_exp_moving_time_range = /** @type {(inputs: Exp_Moving_Time_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On rides, coasting without pedalling still counts.`)
};

const de_exp_moving_time_range = /** @type {(inputs: Exp_Moving_Time_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Radfahren zählt Rollen ohne Treten mit.`)
};

/**
* | output |
* | --- |
* | "On rides, coasting without pedalling still counts." |
*
* @param {Exp_Moving_Time_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_moving_time_range = /** @type {((inputs?: Exp_Moving_Time_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Moving_Time_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_moving_time_range(inputs)
	return de_exp_moving_time_range(inputs)
});